import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { AuthSelectors } from '@app/modules/Auth'
import { NavBarEntry } from '@app/NavBar'
import { useNavBarCountersLazyQuery } from '@app/queries/NavBar/NavBarCounters.queries'

import { getAuditReportsPath } from './paths'

export function useNavbarEntries(): NavBarEntry[] {
  const lawyerId = useSelector(AuthSelectors.getUserId)
  const location = useLocation()

  const [count, { data }] = useNavBarCountersLazyQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      lawyerId
    }
  })

  useEffect(() => {
    count()
  }, [location])

  return [
    {
      counter: data?.casesWithoutAppointments ?? 0,
      iconName: 'checklist',
      title: 'Prüfungsberichte',
      EntryWrapper: ({ children }) => <Link to={getAuditReportsPath()}>{children}</Link>,
      active: /^\/pruefungsberichte/
    }
  ]
}
